export const APP_ORIGIN = import.meta.env.DEV
  ? 'http://localhost:5173'
  : 'https://app.exis.pro';

import type { BillingFrequency } from './billing/billingFrequency';

export const PRO_TRIAL_RETURN = '/settings/billing?start=trial';

export function appSignupForProTrial(frequency: BillingFrequency): string {
  const returnTo =
    frequency === 'year'
      ? `${PRO_TRIAL_RETURN}&cadence=year`
      : PRO_TRIAL_RETURN;
  return `${APP_ORIGIN}/login?return_to=${encodeURIComponent(returnTo)}`;
}
